import { DatePicker } from 'antd';
import { FC, PropsWithChildren } from 'react';

import { RangeEventValue } from 'src/utils/date-util';

import classes from './TableOptions.module.scss';

const { RangePicker } = DatePicker;

interface TableOptionsProps {
  setDates: (value: RangeEventValue) => void;
  defaultValue?: RangeEventValue;
  value?: RangeEventValue;
  marginBottom?: number;
  disabled?: boolean;
}

const TableOptions: FC<PropsWithChildren<TableOptionsProps>> = ({
  children,
  setDates,
  defaultValue,
  value,
  marginBottom,
  disabled,
}) => {
  return (
    <div className={classes.tableOptions} style={{ marginBottom }}>
      <RangePicker
        {...(value ? { value: value ?? undefined } : { defaultValue: defaultValue ?? undefined })}
        onCalendarChange={(val) => setDates(val as RangeEventValue)}
        disabled={disabled}
      />
      <div className={classes.marginBox} />
      {children}
    </div>
  );
};

export default TableOptions;
